





import Vue from 'vue';
import axios from 'axios';
import api from '../api';
import Followup from '../components/Followup.vue';
export default Vue.extend({
  name: 'followup',
  data() {
    return {};
  },
  components: {
    Followup
  }
});
